export default {
	title: "Feed of activity on this key result. Activity also rolls up to aggregate activity view at the goal level.",
};
